import { Card as CardAntd } from 'antd';
import clsx from 'clsx';
import React from 'react';
const Card = ({ noPadding = false, noShadow = false, noBorder = false, children, className, showBackground = false, ...rest }) => {
    return (React.createElement(CardAntd, { className: clsx('relative', className, noPadding ? 'no-padding' : '', noShadow ? 'no-shadow' : '', noBorder && 'no-border'), ...rest }, children));
};
export default Card;
